<template>
  <v-container fluid>
    <v-data-table class="pt-3" flat :loading="loading ? '#0482fb' : null" :headers="headers" :items="ContractsList"
      :items-per-page="5" sort-by="">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Listing des contrats</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-switch v-model="showAllFil" label="Afficher toutes les données" color="#0482fb" @change="showAllFillData"
            class="pt-5"></v-switch>
        </v-toolbar>
        <v-container fluid>
          <v-expansion-panels flat style="border: 1px solid #0482fb">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header>
                Tri / Recherche ...
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date émission début" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="periodStartDate" type="date" dense flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date émission fin" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="periodEndDate" type="date" dense flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <!-- <v-col cols="12" md="3">
                    <v-text-field outlined  
                      color="#0482fb"
                      label="Date effet début"
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      v-model="effectStartDate"
                      type="date"
                       
                      dense
                      
                      flat
                      background-color="grey lighten-4"
                      
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined  
                      color="#0482fb"
                      label="Date effet fin"
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      v-model="effectEndDate"
                      type="date"
                       
                      dense
                      
                      flat
                      background-color="grey lighten-4"
                      
                    ></v-text-field
                  ></v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined  
                      color="#0482fb"
                      label="Date echéance début"
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      v-model="dueStartDate"
                      type="date"
                       
                      dense
                      
                      flat
                      background-color="grey lighten-4"
                      
                    ></v-text-field
                  ></v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined  
                      color="#0482fb"
                      label="Date echéance fin"
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      v-model="dueEndDate"
                      type="date"
                       
                      dense
                      
                      flat
                      background-color="grey lighten-4"
                      
                    ></v-text-field 
                  ></v-col> -->
                  <v-col cols="12" md="2">
                    <v-autocomplete outlined :items="userFile" class="pt-5 pa-2 mx-2" prepend-inner-icon="mdi-magnify"
                      v-model="fileName" dense flat background-color="grey lighten-4" label="Nom / Raison Sociale ...">
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete outlined :items="companyNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                      dense v-model="company" flat background-color="grey lighten-4"
                      label="Compagnie ..."></v-autocomplete></v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                      dense v-model="product" flat background-color="grey lighten-4"
                      label="Produit"></v-autocomplete></v-col>
                  <!-- <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Nom / Raison Sociale ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="fileName" flat
                      background-color="grey lighten-4"></v-text-field></v-col> -->
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro Police ..." class="pt-5 pa-2"
                      v-model="policeNumber" prepend-inner-icon="mdi-magnify" dense flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro Avenant ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="plugged" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro Emission ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="emissionNumber" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro Quittance ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="receiptNumber" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro Client ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="customerNumber" flat
                      background-color="grey lighten-4"></v-text-field></v-col>

                  <v-col cols="12" md="2">
                    <v-select outlined :items="avenantList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="actionType" flat background-color="grey lighten-4"
                      label="Type d'avenant"></v-select></v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="white--text mr-2" color="#0482fb" pill @click="onEnter">
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Appliquer la recherche
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </template>
      <template v-slot:item.name="{ item }">
        <td>
          {{ item.file.name }}
        </td>
      </template>
      <template v-slot:item.company="{ item }">
        <td>
          {{ item.company && item.company.name ? item.company.name : "" }}
        </td>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu elevation="0" right offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
              <v-icon color="success" size="30">mdi-forwardburger</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-tooltip bottom color="warning">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="editItem(item)" v-bind="attrs" v-on="on"
                    color="warning">mdi-pencil-box-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Modification du contrat sélectionné</span>
            </v-tooltip>
            <v-tooltip bottom color="black">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="handleClickFacture(item)" color="black" v-bind="attrs" v-on="on">
                    mdi-cash-register</v-icon>
                </v-btn>
              </template>
              <span>Facture</span>
            </v-tooltip>
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" color="success" v-bind="attrs" v-on="on"
                    @click="startNewContract(item)">mdi-checkbox-marked-circle-plus-outline</v-icon>
                </v-btn>
              </template>
              <span>Mise en place d'un nouveau contrat</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" v-bind="attrs" v-on="on" @click="getSinisterDeclaration(item)">mdi-ambulance</v-icon>
                </v-btn>
              </template>
              <span>Déclaration d'un sinistre</span>
            </v-tooltip>

            <v-tooltip bottom color="error">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon @click="initCancelContract(item)" v-bind="attrs" v-on="on" size="20"
                    color="error">mdi-book-cancel-outline</v-icon>
                </v-btn>
              </template>
              <span>Annuler ce contrat</span>
            </v-tooltip>
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="handleClickMailGed(item)" color="success" v-bind="attrs" v-on="on">
                    mdi-file-document-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Gestion des fichiers </span>
            </v-tooltip>

          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <v-dialog v-model="addFileMailGed" max-width="900px">
      <v-card style="border-top: 10px solid #0482fb">
        <v-card-title>
          <span class="text-h4  mb-5 mt-5" style="color:#0482fb;font-weight: bold;">Gestionnaire de fichier</span>
        </v-card-title>
        <v-item-group multiple>
          <v-container>
            <!-- {{filesListe}} -->
            <v-row>
              <v-col v-for="n in filesListe" :key="n" cols="12" md="4">
                <v-item>
                  <v-card style="border: 2px solid #0482fb" class="d-flex align-center" height="250">
                    <v-card-text style="height: 100px; position: relative">
                      <h4 style="text-align: center;">
                        {{ n.filename }}
                      </h4>
                      <v-fab-transition>
                        <v-btn class="white--text  mt-10" color="#0482fb" :href="n.path" target="_blank" dark absolute
                          route bottom right fab>
                          <v-icon target="_blank" route :href="n.path">mdi-download</v-icon>
                        </v-btn>
                      </v-fab-transition>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
      </v-card>
    </v-dialog>
    <!-- factue contrat -->
    <v-dialog transition="dialog-bottom-transition" max-width="500" overlay v-model="factureDialog">
      <v-card style="border-top:10px solid red">
        <v-card-title>Imprimer une facture</v-card-title>
        <v-card-text>
          <div class=" pt-6 ">

            <v-autocomplete outlined :items="['DOIT', 'AVOIR']" color="#0482fb" class=""
              prepend-inner-icon="mdi-nature-people" v-model="invoiceInformation.invoiceNature" dense flat
              background-color="grey lighten-4" label="Nature de facture">
            </v-autocomplete>

          </div>
        </v-card-text>
        <v-card-actions class="justify-end pb-6">
          <!-- <v-btn text @click="(cancelDialog = false), (cancelModal = {})">Annuler</v-btn> -->
          <v-btn color="success" class="white--text" @click="printSimpleFacture('simple')">Imprimer Facture
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" class="white--text" @click="printSimpleFacture('PROFORMA')">Imprimer Facture Proforma
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Cancel contrat -->
    <v-dialog transition="dialog-bottom-transition" max-width="500" overlay v-model="cancelDialog">
      <v-card style="border-top:10px solid red">
        <v-card-text>
          <div class=" pt-6 ">
            Un nouveau contrat sera créé avec la valeur négative des montants du
            contrat actuel
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="(cancelDialog = false), (cancelModal = {})">Annuler</v-btn>
          <v-btn color="error" class="white--text" @click="saveCancelContract">Confirmer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  Déclaration sinistre-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog v-model="sinisterDialog" overlay transition="dialog-bottom-transition" scrollable max-width="1000px">
            <v-form ref="form" lazy-validation>
              <v-card style="border-top:10px solid #0482fb " tile>
                <v-card-text>
                  <h2 class="pt-8 pl-3">Prise de déclaration sinsitre</h2>
                  <v-container fluid>
                    <v-row align="center">
                      <!-- <v-col cols="12" sm="3">
                      <v-text-field outlined  
            color="#0482fb"
                        v-model="sinisterAskNumber"
                        label="Numéro sinistre DAYO"
                      ></v-text-field>
                    </v-col> -->
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.sinisterCompanyNumber"
                          label="Numéro sinistre compagnie"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.dateOfOccurrence" type="date"
                          :rules="[
                            (v) => !!v || 'Date de survenance non remplie',
                          ]" label="Date  survenance"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.declarationDate" type="date"
                          label="Date déclaration"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.companyDispatchDate" type="date"
                          label="Date envoi compagnie"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.driverName"
                          label="Nom conducteur"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.conductiveContact"
                          label="Contact conducteur"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.registrationValidationDate"
                          type="date" label="Date retour compagnie"></v-text-field>
                      </v-col>

                      <v-col cols="12" md="12">
                        <v-textarea outlined v-model="declarationModal.circumstance" name="input-7-4"
                          label="Circonstance du sinistre" value=""></v-textarea>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" disabled v-model="declarationModal.PSAP" type="number"
                          label="PSAP"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.disasterObject"
                          label="Objet sinistré"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.materialDamageInsured"
                          label="Dommages matériels assuré"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.insuredBodilyInjury"
                          label="Dommages coporels assuré"></v-text-field>
                      </v-col>

                      <v-col cols="12" md="12">
                        <v-textarea outlined v-model="declarationModal.observation" name="input-7-4"
                          label="Renseignements Tiers" value=""></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-row justify="end">
                    <v-btn tile color="error" text @click="sinisterDialog = false">
                      Fermer
                    </v-btn>
                    <v-btn tile color="success" class="ml-10" @click="cashIn">
                      Enregistrer
                    </v-btn>
                  </v-row>
                </v-card-text>

                <div style="flex: 1 1 auto"></div>
              </v-card>
            </v-form>
          </v-dialog>
        </v-row>
      </div>
    </template>
    <!--  Pop up des Contrat-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog v-model="contractDialog" overlay transition="dialog-bottom-transition" max-width="1000px">
            <save-dialog v-if="contractDialog" @success="successSaveContract" @closeDialog="closeContract"
              :modal="contractModal" />
          </v-dialog>
        </v-row>
      </div>
      <v-dialog v-model="Shodialog" max-width="490">
        <v-card class="pt-5" style="text-align:center,">
          <v-card-text>{{ testAlert }} </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import { addFile, updateFile } from "@/api/admin";
import {
  cancelContract,
  createDeclaration,
  updateContract,
  addContract,
} from "@/api/user.js";
import SaveDialog from "../components/contrat/saveDialog.vue";
export default {
  name: "production",
  components: { SaveDialog },
  data: () => ({
    perssonel: [],
    addFileMailGed: false,
    items: ["NSIA", "SANLAM", "SAHAM", "ATLANTIQUE ASSURANCE"],
    natureprospect: ["Physics", "Entreprise"],
    Shodialog: false,
    contractDialog: false,
    invoiceInformation: {
      invoiceNature: "",
      invoiceContractId: "",

    },
    filesListe: [],
    filesListeQuitance: [],
    filesListePayement: [],
    headers: [
      {
        text: "Actions",
        width: "100px",
        align: "left",
        value: "actions",
        sortable: false,
      },
      {
        text: "Nom / Raison Sociale",
        width: "200px",
        // align: "start",
        value: "name",
      },
      { text: "Branche", width: "200px", value: "product" },
      { text: "Catégorie", width: "200px", value: "category" },
      { text: "Compagnie", width: "200px", value: "company" },
      { text: "Type Avenant", width: "200px", value: "actionType" },
      { text: "Numéro police", width: "200px", value: "policeNumber" },
      { text: "Numéro avenant", width: "200px", value: "plugged" },
      { text: "Date émission", width: "200px", value: "createdAtFr" },
      { text: "Effet", width: "200px", value: "effectDateFr" },
      { text: "Echeance", width: "200px", value: "dueDateFr" },
      { text: "Prime Nette", width: "200px", value: "netPrime" },
      { text: "Prime TTC", width: "200px", value: "totalPrime" },
    ],
    contrat: [
      {
        name: "gras savoye",
        company: "NSIA",
        endorsementType: "Affaire nouvelle",
        policeNumber: "2021445588",
        endorsementNumber: "2020114455",
        plugged: "Automobile",
        effect: "22/08/2022",
        dueDate: "31/12/2022",
        primeTTC: "1500000",
      },
    ],
    currentProduct: null,
    avenantList: [
      "Affaire Nouvelle",
      "Renouvellement",
      "Incorporation",
      "Retrait",
      "Suspension",
      "Remise en vigeur",
      "Precision",
      "Modification",
      "Resiliation",
      "Régularisation",
      "Prérogation",
      "Changement d'immatriculation",
    ],
    proposedProductNameList: [],
    companyNameList: [],
    productNameList: [],
    coinsuranceCompanyNameList: [],
    CommercialNameList: [],
    prospectsNameList: [],
    Contract: "",
    factureDialog: false,
    contractModal: {
      accessory100: 0,
      accessory50: 0,
    },
    incorporationModal: {},
    regulationClauseModal: {
      reminderDate: "",
      companyRequestDate: "",
      companyReturnDate: "",
      customerRequestDate: "",
      customerReturnDate: "",
    },
    pbClauseModal: {
      reminderDate: "",
      companyRequestDate: "",
      companyReturnDate: "",
      customerRequestDate: "",
      customerReturnDate: "",
    },

    coinsuranceModal: [
      {
        shareRate: 0,
        company: "",
        observation: "",
      },
    ],
    customerReturnDialog: false,
    categorie: [],
    companyReturnDialog: false,
    contratsearchData: "",
    companyReturnModal: {},
    fileName: "",
    product: "",
    policeNumber: "",
    plugged: "",
    company: "",
    prospectdata: [],
    editedIndex: -1,
    fileModal: {
      name: "",
      nature: "",
      phone: "",
      activity: "",
      email: "",
      birthday: "",
      location: "",
      prospects: [],
    },
    defaultItem: {
      nom: "",
      Nature: "",
      Contact: "",
      Activité: "",
      Mail: "",
      Anniverssaire: "",
      Localisation: "",
    },
    email: "",
    name: "",
    contact: "",
    birthday: "",
    declarationModal: [],
    dialogDelete: false,
    cancelDialog: false,
    sinisterDialog: false,
    emailRules: [
      (v) => !!v || "E-mail is ",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    loader: false,
    loading: false,
    fileDialog: false,
  }),

  mounted() {
    this.initQuotingRequest();
    // this.$refs.calendar.checkChange();
  },
  computed: {
    ...mapGetters([
      "Files",
      "QuotingRequests",
      "ContractsList",
      "Products",
      "Companies",
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? "Ajouter Dossier Production"
        : "Modifier Dossier Production ";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    contractModal() { },
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
    },
    Products() {
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
    Files() {
      this.userFile = defaultMethods.getNameList(this.Files.docs);
    },
    Contract() {
      if (this.Contract) {
        this.contractModal = this.Contract;
        this.contractModal.company = defaultMethods.getItemName(
          this.Companies.docs,
          this.contractModal.company
        );
        this.contractModal.commercial = defaultMethods.getItemName(
          this.Users.docs,
          this.contractModal.commercial
        );

        // this.contractModal.dueDate =
        //   this.contractModal.dueDate
        // this.contractModal.effectDate =
        //   this.contractModal.effectDate
        // this.contractModal.paymentDate =
        //   this.contractModal.paymentDate

        if (this.Contract.otherInfo) {
          // clause regulation
          if (this.Contract.otherInfo.regulationClause) {
            this.regulationClauseModal = this.Contract.otherInfo.regulationClause;
          }

          // pb clause
          // clause regulation
          if (this.Contract.otherInfo.pbClause) {
            this.pbClauseModal = this.Contract.otherInfo.pbClause;
          }

          // coinsurance
          if (this.Contract.otherInfo.coinsurance) {
            this.coinsuranceModal = this.Contract.otherInfo.coinsurance;
            for (let i = 0; i < this.coinsuranceModal.length; i++) {
              this.coinsuranceModal[i].company = defaultMethods.getItemName(
                this.Companies.docs,
                this.coinsuranceModal[i].company
              );
            }
          }
        }
      } else {
        this.contractModal = {
          accessory100: 0,
          accessory50: 0,
        };
      }
    },
  },

  methods: {
    ...mapActions([
      "getQuotingRequests",
      "getContracts",
      "postSearchContratTrue",
      "getProducts",
      "getFiles",
      "getCompanies",
      "getDocFactureEmission"
    ]),

    closeForm() {
      this.fileModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = false;
      this.dialogDelete = false;

      this.editedIndex = -1;
    },
    handleClickFacture(item) {
      // console.log(item)

      this.invoiceInformation.invoiceContractId = item._id
      this.factureDialog = true
    },
    async printSimpleFacture(item) {
      // alert(item)


      try {
        const schemas = {
          invoiceNature: this.invoiceInformation.invoiceNature,
        }
        if (this.invoiceInformation.invoiceContractId) {
          // alert(this.invoiceInformation.invoiceContractId)
          await updateContract({
            schema: schemas,
            id: this.invoiceInformation.invoiceContractId,
          });
        }
        const schema = {
          invoiceNature: this.invoiceInformation.invoiceNature,
          type: item
        }
        await this.getDocFactureEmission(
          { schema, id: this.invoiceInformation.invoiceContractId, });
      }
      catch (error) {
        defaultMethods.dispatchError(this.$store);
      }

      // defaultMethods.dispatchSuccess(
      //   this.$store,
      //   messages.canceledSuccessfully("Ce contrat")
      // );
    },
    showAllFillData() {
      this.initQuotingRequest();
      //alert(this.showAllFil);
    },
    closeCancel() {
      this.cancelModal = {};
      this.cancelDialog = false;
    },
    async saveCancelContract() {
      this.loading = true;
      try {
        // add

        await cancelContract({ id: this.contractModal._id });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.canceledSuccessfully("Ce contrat")
        );
        this.closeCancel();
        this.initQuotingRequest();
      } catch (error) {
        // alert(error);
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    startNewContract(item) {
      //alert(this.Contract.productName)

      this.contractModal = {
        accessory100: 0,
        accessory50: 0,
      };
      switch (this.Contract.productName) {
        case "ASSURANCE CAUTION":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT BAIL":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "MALADIE":
          {
            this.categorie = ["MALADIE", "GESTION CONFIEE"];
          }
          break;
        case "ASSURANCES TRANSPORTS":
          {
            this.categorie = ["TERRESTRE", "MARITIME", "AERIEN", "FERROVIAIRE"];
          }
          break;
        case "AUTOMOBILE":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO", "FLOTTE MOTO", "MONO MOTO "];
          }
          break;


        case "BRIS DE MACHINE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "FAUX PAIEMENTS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "GLOBALE DE BANQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;


        case "GLOBALE DOMMAGES":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "INDEMNITE DE FIN DE CARRIERE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "INDIVIDUELLE ACCIDENTS CORPORELS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;


        case "MULTIRISQUE HABITATION":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;
        case "MULTIRISQUE PROFESSIONNELLE":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;





        case "PREVOYANCE DECES":
          {
            this.categorie = [
              "ASSURANCES DE PERSONNES"
            ];
          }
          break;
        case "RC CHEF D'ENTREPRISE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC CHEF DE FAMILLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE DECENNALE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EXPLOITATION":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "PREVOYANCE PLUS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "RC PROFESSIONNELLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EVENEMENTS SPORTIFS":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;


        case "TOUS RISQUES MONTAGE/ESSAI":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "VOL ":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;



        case "RC SCOLAIRE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RETRAITE COMPLEMENTAIRE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;
        case "TOUS DOMMAGES SAUF":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "TOUS RISQUES CHANTIER":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSISTANCE AU VOYAGE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;



        case "VIOLENCE POLITIQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "RC TRANSPORTEUR":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "TRANSPORT DE FONDS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "DJIGUIYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "EVACUATION SANITAIRE":
          {
            this.categorie = ["MALADIE"];
          }
          break;


        case "ASSURANCE MOYEN DE PAIEMENT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;

        case "AUTOFINANCEMENT":
          {
            this.categorie = ["HONORAIRES PAR BENEFICIAIRE", "HONORAIRES MONTANT FIXE", "HONORAIRES MONTANT NOMINAL", "HONORAIRES CARTE SANTE", "HONORAIRES DE REGULARISATION"];
          }
          break;
        case "INCENDIE SIMPLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "MULTIRISQUE INDUSTRIELLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "AUTOMOBILE TPV":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO"];
          }
          break;
        case "ASSISTANCE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "MOGOBAYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "IKENEYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "HONORAIRES BONUS COMMISSION":
          {
            this.categorie = ["BONUS /MALUS"];
          }
          break;
        case "TEMPORAIRE DECES":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "WGARAGE":
          {
            this.categorie = ["FLOTTE AUTO"];
          }
          break;
      }
      this.contractModal.isNew = true;
      this.seedCtr(item);
      this.contractDialog = true;


    },
    seedCtr(item) {
      this.contractModal = Object.assign({}, item);
      // this.editItemFormat(item);

      this.contractModal.isNew = true;
      this.contractModal.netPrime = 0;
      this.contractModal.accessory100 = 0;
      this.contractModal.TTCPrime = 0;
      this.contractModal.totalPrime = 0;
      this.contractModal.primeRC = 0;
      this.contractModal.accessory50 = 0;
      this.contractModal.commission = 0;
      this.contractModal.commissionRate = 0;
      this.contractModal.effectDate = "";
      this.contractModal.dueDate = "";
      this.contractModal.TACAVA = 0;
      this.contractModal.cdeaoPrime = 0;
      this.contractModal.commission = 0;
      this.contractModal.managerCommission = 0;
      this.contractModal.commissionRate = 0;
      this.contractModal.managerCommissionRate = 0;
      this.contractModal.TVA = 0;
      this.contractModal.haveRegulationClause = "";
      this.contractModal.bank = "";
      this.contractModal.commercialAgent = "";
      this.contractModal.checkNumber = "";
      this.contractModal.paymentMethod = "";
      this.contractModal.havePbClause = "";
      this.contractModal.haveCoinsurance = "";
      this.contractModal.haveReinsurance = "";
      this.contractModal.mailNumberQuittance = "";
      this.contractModal.emissionNumber = "";
      this.contractModal.invoiceNumber = "";
      this.contractModal.purchaseOrder = "";
      this.contractModal.observation = "";
      if (this.Companies && this.Companies.docs) {
        this.contractModal.company = this.contractModal.company.name;
        // alert(this.Contract.productName)
      }
    },
    handleClickMailGed(item) {
      this.filesListe = item.quittances_files;
      this.addFileMailGed = true;
    },
    initCancelContract(item) {
      this.contractModal = Object.assign({}, item);
      this.editItemFormat(item);
      this.cancelDialog = true;
    },
    async initQuotingRequest() {
      this.loading = true;
      try {
        await this.getContracts({
          contractEstablished: true,
          withQuoting: false,
          withoutPeriod: this.showAllFil,
        });
        await this.getFiles({ withoutPeriod: true });
        await this.getProducts({ name: this.searchData });
        await this.getCompanies();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },

    async makeSearchContract() {
      this.loading = true;
      try {
        await this.postSearchContratTrue({
          fileName: defaultMethods.getItemId(this.Files.docs, this.fileName),
          product: this.product,
          policeNumber: this.policeNumber,
          plugged: this.plugged,
          company: this.company,
          contractEstablished: true,
          //withQuoting: true,
          customerNumber: this.customerNumber,
          receiptNumber: this.receiptNumber,
          emissionNumber: this.emissionNumber,
          actionType: this.actionType,
          withoutPeriod: this.showAllFil,
          effectStartDate: this.effectStartDate,
          effectEndDate: this.effectEndDate,
          dueStartDate: this.dueStartDate,
          dueEndDate: this.dueEndDate,
          avenantList: this.avenantList,
          periodStartDate: this.periodStartDate,
          periodEndDate: this.periodEndDate,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },
    onEnter: function () {
      if (
        this.periodStartDate == undefined &&
        this.periodEndDate != undefined
      ) {
        this.testAlert = "";
        this.testAlert =
          "Date création début requis pour la période de recherche";
        this.Shodialog = true;
      } else if (
        this.periodEndDate == undefined &&
        this.periodStartDate != undefined
      ) {
        this.testAlert = "";
        this.testAlert =
          "Date création fin requise pour la période de recherche";
        this.Shodialog = true;
      } else if (
        this.periodStartDate == undefined &&
        this.periodEndDate == undefined
      ) {
        this.testAlert = "";
        this.testAlert = "Veuillez définir la période de recherche";
        this.Shodialog = true;
      } else {
        this.makeSearchContract();
      }
    },
    getSinisterDeclaration(item) {
      this.declarationModal.contentID = item._id;

      this.sinisterDialog = true;
    },
    async cashIn() {
      this.$refs.form.validate();

      if (this.$refs.form.validate()) {
        this.saveDeclaration();
      }
    },
    async saveDeclaration() {
      this.loading = true;

      try {
        const schema = {
          sinisterCompanyNumber: this.declarationModal.sinisterCompanyNumber,
          circumstance: this.declarationModal.circumstance,
          dateOfOccurrence: this.declarationModal.dateOfOccurrence,
          declarationDate: this.declarationModal.declarationDate,
          companyDispatchDate: this.declarationModal.companyDispatchDate,
          driverName: this.declarationModal.driverName,
          conductiveContact: this.declarationModal.conductiveContact,
          registrationValidationDate: this.declarationModal
            .registrationValidationDate,
          PSAP: this.declarationModal.PSAP,
          disasterObject: this.declarationModal.disasterObject,
          insuredBodilyInjury: this.declarationModal.insuredBodilyInjury,
          materialDamageInsured: this.declarationModal.materialDamageInsured,

          observation: this.declarationModal.observation,
          // file: this.File._id,
        };
        if (this.declarationModal.dateOfOccurrence != "") {
          // add
          await createDeclaration({
            schema,
            id: this.declarationModal.contentID,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Declaration")
          );
          this.closeDeclaration();
          this.initQuotingRequest();
        } else {
          defaultMethods.dispatchError("Date survenance requis");
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeDeclaration() {
      this.declarationModal = {};
      this.sinisterDialog = false;
      // this.currentProduct = null;
    },
    async saveProspect() {
      this.loading = true;
      try {
        if (this.fileModal._id) {
          // update
          await updateFile({
            schema: {
              name: this.fileModal.name,
              prospects: this.fileModal.prospects,
              phone: this.fileModal.phone,
              email: this.fileModal.email,
              nature: this.fileModal.nature,
              location: this.fileModal.location,
              description: this.fileModal.description,
              activityField: this.fileModal.activityField,
              birthday: this.fileModal.birthday,
              // proposedProducts: this.fileModal.proposedProducts,
            },
            id: this.fileModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );
          this.closeForm();
          this.initQuotingRequest();
        } else {
          // add
          await addFile(this.fileModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Dossier")
          );
          this.closeForm();
          this.initQuotingRequest();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    all() {
      this.panel = [...Array(this.items.length).keys()].map((k, i) => i);
    },
    addPersonnel() {
      this.fileModal.prospects.push({
        fullName: this.name,
        email: this.email,
        contact: this.contact,
        birthday: this.birthday,
      });

      this.initPersonnelForm();
    },
    async saveContract() {
      this.loading = true;
      try {
        const schema = {
          policeNumber: this.contractModal.policeNumber,
          plugged: this.contractModal.plugged,
          actionType: this.contractModal.actionType,
          category: this.contractModal.category,
          company: defaultMethods.getItemId(
            this.Companies.docs,
            this.contractModal.company
          ),
          // commercial: defaultMethods.getItemId(
          //   this.Users.docs,
          //   this.contractModal.commercial
          // ),
          effectDate: this.contractModal.effectDate,
          dueDate: this.contractModal.dueDate,
          // paymentDate: this.contractModal.paymentDate,
          netPrime: this.contractModal.netPrime,
          // commission: this.contractModal.commission,
          totalPrime: this.contractModal.totalPrime,
          cdeaoPrime: this.contractModal.cdeaoPrime,
          observation: this.contractModal.observation,
          accessory100: this.contractModal.accessory100,
          accessory50: this.contractModal.accessory100 / 2,
        };

        if (!this.contractModal.isNew) {
          // update
          await updateContract({
            schema,
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Contract")
          );
          this.closeContract();
          this.initQuotingRequest();
        } else {
          // add
          schema.product = this.Contract.product;
          schema.fromContract = this.Contract._id;
          // schema.product = defaultMethods.getItemId(
          //   this.File.proposedProducts,
          //   this.currentProduct
          // );
          schema.file = this.File._id;
          await addContract({ schema, id: this.$route.params.id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    successSaveContract() {
      this.initQuotingRequest();
      this.closeContract();
    },
    closeContract() {
      this.contractDialog = false;
      this.seedCtr();
      this.initQuotingRequest();
      // this.currentProduct = null;
      this.incorporationDialog = false;
      this.incorporationModal = {};
      this.withDrawModal = false;
      this.regulationDialog = false;
      this.pbDialog = false;
    },
    editItemFormat(item) {
      // alert(JSON.stringify(item.managerCommission))
      item = defaultMethods.arrayFieldsToInteger(item);

      this.contractModal.totalPrime = item.totalPrime;
      // this.contractModal.TTCPrime = item.totalPrime;
      this.contractModal.netPrime = item.netPrime;
      this.contractModal.primeRC = item.primeRC;
      this.contractModal.commission = item.commission;
      this.contractModal.cdeaoPrime = item.cdeaoPrime;
      this.contractModal.accessory100 = item.accessory100;
      this.contractModal.accessory50 = item.accessory50;
      this.contractModal.managerCommissionRate = item.managerCommissionRate;
      this.contractModal.managerCommission = item.managerCommission;
    },
    editItem(item) {
      // alert(JSON.stringify(item))
      this.contractModal = Object.assign({}, item);
      this.editItemFormat(item);
      if (this.Companies && this.Companies.docs) {
        this.contractModal.company = this.contractModal.company.name;
        // alert(this.Contract.productName)
      }
      switch (this.Contract.productName) {
        case "ASSURANCE CAUTION":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT BAIL":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "MALADIE":
          {
            this.categorie = ["MALADIE", "GESTION CONFIEE"];
          }
          break;
        case "ASSURANCES TRANSPORTS":
          {
            this.categorie = ["TERRESTRE", "MARITIME", "AERIEN", "FERROVIAIRE"];
          }
          break;
        case "AUTOMOBILE":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO", "FLOTTE MOTO", "MONO MOTO "];
          }
          break;


        case "BRIS DE MACHINE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "FAUX PAIEMENTS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "GLOBALE DE BANQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;


        case "GLOBALE DOMMAGES":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "INDEMNITE DE FIN DE CARRIERE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "INDIVIDUELLE ACCIDENTS CORPORELS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;


        case "MULTIRISQUE HABITATION":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;
        case "MULTIRISQUE PROFESSIONNELLE":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;





        case "PREVOYANCE DECES":
          {
            this.categorie = [
              "ASSURANCES DE PERSONNES"
            ];
          }
          break;
        case "RC CHEF D'ENTREPRISE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC CHEF DE FAMILLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE DECENNALE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EXPLOITATION":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "PREVOYANCE PLUS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "RC PROFESSIONNELLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EVENEMENTS SPORTIFS":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;


        case "TOUS RISQUES MONTAGE/ESSAI":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "VOL ":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;



        case "RC SCOLAIRE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RETRAITE COMPLEMENTAIRE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;

        case "TOUS DOMMAGES SAUF":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "TOUS RISQUES CHANTIER":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSISTANCE AU VOYAGE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;



        case "VIOLENCE POLITIQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "RC TRANSPORTEUR":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "TRANSPORT DE FONDS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "DJIGUIYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "EVACUATION SANITAIRE":
          {
            this.categorie = ["MALADIE"];
          }
          break;


        case "ASSURANCE MOYEN DE PAIEMENT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;






        case "AUTOFINANCEMENT":
          {
            this.categorie = ["HONORAIRES PAR BENEFICIAIRE", "HONORAIRES MONTANT FIXE", "HONORAIRES MONTANT NOMINAL", "HONORAIRES CARTE SANTE", "HONORAIRES DE REGULARISATION"];
          }
          break;
        case "INCENDIE SIMPLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "MULTIRISQUE INDUSTRIELLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "AUTOMOBILE TPV":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO"];
          }
          break;
        case "ASSISTANCE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "MOGOBAYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "IKENEYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "HONORAIRES BONUS COMMISSION":
          {
            this.categorie = ["BONUS /MALUS"];
          }
          break;
        case "TEMPORAIRE DECES":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "WGARAGE":
          {
            this.categorie = ["FLOTTE AUTO"];
          }
          break;
      }

      this.contractDialog = true;
    },

    initPersonnelForm() {
      this.name = "";
      this.email = "";
      this.contact = "";
      this.birthday = "";
    },
    // Reset the panel
    none() {
      this.panel = [];
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    addProspect() {
      this.editedIndex = -1;
      this.fileModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = true;
    },
    updateProspect(item) {
      this.editedIndex = 1;
      this.fileModal = Object.assign({}, item);
      this.fileDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.fileModal = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.prospectdata.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.fileModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.fileModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.prospectdata[this.editedIndex], this.fileModal);
      } else {
        this.prospectdata.push(this.fileModal);
      }
      this.close();
    },
  },
};
</script>

<style scoped></style>
